const redirectSiteResume = () => {
  const gammaUrl = "https://maria-roman-domingo-g66agjd.gamma.site/";
  window.open(gammaUrl, '_blank');
};

export default redirectSiteResume;